import { FC, lazy, Suspense } from 'react'
import {
  MinimalLoader,
  FinanceCalculatorThemeProvider,
  usePlatformConfig,
} from '@dxp-module/common'

const ReverseCalculatorForm = lazy(
  () => import('./reverseCalculatorForm/ReverseCalculatorForm')
)

const ReverseCalculatorWidgetContent: FC = () => {
  const {
    platformConfig: { themeOverride },
  } = usePlatformConfig()

  return (
    <FinanceCalculatorThemeProvider themeOverride={themeOverride}>
      <Suspense fallback={<MinimalLoader />}>
        <ReverseCalculatorForm />
      </Suspense>
    </FinanceCalculatorThemeProvider>
  )
}

export default ReverseCalculatorWidgetContent
